<template>
  <router-link
    tag="a"
    class="columns"
    :to="{ name: 'getQuote', query: { type: 'AT' } }"
  >
    <div class="container is-hidden-touch">
      <div class="columns is-gapless">
        <div class="column">
          <div class="content">
            <h1><strong>4.6</strong> out of <strong>5 Stars</strong></h1>
            <p><strong>"Excellent" Rated Travel Insurance</strong></p>
            <ul>
              <router-link
                :to="{ name: 'covid19Cover' }"
                tag="li"
                class="bullet"
              ><strong>Superior Rated Covid Cover</strong></router-link
              >

              <li class="bullet">
                <strong>24/7</strong> Emergency Medical
                <strong>Assistance</strong>
              </li>
              <li class="bullet">
                All
                <strong>Pre-existing Medical Conditions</strong> <br />
                considered
              </li>
            </ul>
            <router-link
              :to="{ name: 'getQuote', query: { type: 'AT' } }"
              tag="button"
              class="hvr-shadow-radial"
              >GET A QUOTE</router-link
            >
            <router-link
              :to="{ name: 'covid19Cover' }"
              tag="p"
              class="bottom-link"
              >More Info</router-link
            >
            <img style="max-width: 325px;position:absolute;right: 140px;top:50px" src="../../assets/images/halloween2022.png" alt="Halloween Promo 2022"/>
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.container {
  background: url('../../assets/images/seefromthesky.jpg') no-repeat top right;
  background-size: 70% 120%;
  border-radius: 0 5px 5px 0;
}

.content {
  background: linear-gradient(
    90deg,
    rgba(8, 53, 105, 1) 0%,
    rgba(8, 53, 105, 1) 30%,
    rgba(8, 53, 105, 0) 70%,
    rgba(255, 255, 255, 0) 100%
  );
  color: white;
  padding: 30px;
  border-radius: 5px 0 0 5px;
  strong {
    color: white;
  }
  h1 {
    color: white;
    font-weight: 200;
    margin-left: 80px;
    margin-bottom: 5px;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 10px 0 30px 10px;
    font-weight: 200;
    .bullet {
      font-size: 20px;
      background: url('../../assets/images/icons/bullet-tick-md-blue.png') no-repeat 0px 0px;
      height: 50px;
      padding-left: 40px;
      padding-top: 6px;
      margin-bottom: 0px;
    }
    li {
      margin-top: 0px;
      margin-bottom: 0px;
    }
  }
  button {
    background-color: $c2g_orange;
    border: 0;
    width: 250px;
    height: 50px;
    color: white;
    font-size: 22px;
    cursor: pointer;
    margin-left: 90px;
    border-radius: 5px;
  }
  p {
    font-size: 20px;
    color: white;
    margin-bottom: 5px;
    font-weight: 200;
    margin-left: 50px;
  }

  .bottom-link {
    margin-top: 10px;
    margin-left: 100px;
    text-decoration: underline;
    margin-left: 170px;
    cursor: pointer;
  }
}
</style>
